import { ToastContainer } from 'react-toastify';

export const ToastContainerWrapper = () => {
  return <ToastContainer position="top-left" autoClose={10_000} theme="light" />;
};
